import { Col, Container, Row } from "react-bootstrap";
import { BackLink, CTA, Description, Image, Title, Time } from "@/ui";
import clsx from "classnames";
import classes from "./styles.module.scss";

export default function HeaderSideImage({ className, containerClassName, img, back, title, description, cta, reading_time }) {
  return (
    <div className={clsx(className, classes.header)}>
      <Container fluid className={containerClassName}>
        <Row>
          <Col xs={12} md={6} className={clsx(classes.header__content, "py-5")}>
            <BackLink back={back} />
            <Title className={clsx(title?.className, "mb-0")} title={title} tag="h1" />
            <div className="description me-4">
              <Description className="mt-4" description={description} />
              {cta && <CTA className="mt-5" label={cta.label} href={cta.href} variant={cta.variant} />}
            </div>
            <Title className={"mt-5 mb-0 px-3 py-2 d-inline border border-2 border-tertiary rounded-5"} title={reading_time} tag="span" />
          </Col>
          <Col xs={12} md={6} className="px-0">
            <Image img={img} resize={false} alt="Header image" />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

HeaderSideImage.defaultProps = {
  containerClassName: "mw-xxl",
};
